"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _Style = require("../core/Style");

var _UIClickable = _interopRequireDefault(require("../button/UIClickable"));

var _UIIconCircle = _interopRequireDefault(require("../icon/UIIconCircle"));

var _IconConstants = require("../icon/IconConstants");

var _colors = require("HubStyleTokens/colors");

var _sizes = require("HubStyleTokens/sizes");

var _component = _interopRequireDefault(require("../utils/propTypes/component"));

var DefaultStepIconComponent = function DefaultStepIconComponent(_ref) {
  var defaultIcon = _ref.defaultIcon;
  return defaultIcon;
};

var getCircleSize = function getCircleSize(size) {
  return _IconConstants.ICON_SIZES[size] || size;
};

var getKeyFromStep = function getKeyFromStep(stepElement) {
  if (!_react.default.isValidElement(stepElement)) return stepElement;
  var key = stepElement.key;

  if (typeof key !== 'string') {
    _devLogger.default.warn({
      message: 'UIStepIndicator: stepName elements must have a `key`',
      key: 'UIStepIndicator-stepName-key'
    });
  }

  return key;
};

var renderStep = function renderStep(step, circleSize, direction) {
  var lineHeightOffset = parseInt(_sizes.BASE_LINE_HEIGHT, 10) / 2;
  var labelSeparationX = 10;
  var itemOffsetX = direction === 'vertical' ? (0, _Style.remCalc)(getCircleSize(circleSize) * 2 + labelSeparationX) : null;
  var itemOffsetY = direction === 'vertical' ? (0, _Style.remCalc)(getCircleSize(circleSize) - lineHeightOffset) : null;
  return _react.default.createElement("div", {
    className: "private-step-indicator__item",
    style: {
      marginLeft: itemOffsetX,
      marginTop: itemOffsetY
    }
  }, _react.default.createElement("span", {
    className: "private-step-indicator__text"
  }, step));
};

var renderSteps = function renderSteps(circleSize, direction, onStepClick, stepIndex, stepNames, StepIconComponent) {
  var stepStatus = 'incomplete';
  return stepNames.map(function (stepName, index) {
    if (index < stepIndex && stepIndex > 0) {
      stepStatus = 'complete';
    } else if (index === stepIndex) {
      stepStatus = 'active';
    } else if (stepStatus === 'active') {
      // If stepStatus is "active", then all subsequent steps are incomplete
      stepStatus = 'incomplete';
    }

    var clickableClass = onStepClick && index !== stepIndex ? 'private-step-indicator__clickable' : undefined;
    var classes = (0, _classNames.default)('private-step-indicator__section', "private-step-indicator__section--" + stepStatus, clickableClass);

    var stepIcon = _react.default.createElement(_UIIconCircle.default, {
      legacy: true,
      color: stepStatus === 'complete' ? _colors.OLAF : _colors.LORAX,
      backgroundColor: stepStatus === 'complete' ? _colors.LORAX : _colors.OLAF,
      borderColor: "currentColor",
      borderWidth: 2,
      className: "private-step-indicator__point",
      name: stepStatus === 'complete' ? 'success' : 'blank',
      size: getCircleSize(circleSize)
    });

    var StepIndicatorWrapper = onStepClick && index !== stepIndex ? _UIClickable.default : 'div';
    return _react.default.createElement(StepIndicatorWrapper, {
      "aria-current": stepStatus === 'active' ? 'step' : false,
      className: classes,
      key: getKeyFromStep(stepName),
      onClick: onStepClick && index !== stepIndex ? function () {
        return onStepClick(index);
      } : undefined
    }, _react.default.createElement("div", {
      className: "private-step-indicator__line"
    }, _react.default.createElement("span", {
      className: "private-step-indicator__point"
    }, _react.default.createElement(StepIconComponent, {
      stepIndex: stepIndex,
      stepStatus: stepStatus,
      index: index,
      circleSize: circleSize,
      defaultIcon: stepIcon
    }))), renderStep(stepName, circleSize, direction));
  });
};

var UIStepIndicator =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(UIStepIndicator, _PureComponent);

  function UIStepIndicator(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UIStepIndicator);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIStepIndicator).call(this, props));
    _this.state = {
      isWidthConstrained: false
    };
    _this.refCallback = _this.refCallback.bind((0, _assertThisInitialized2.default)(_this));
    _this.measureWidth = _this.measureWidth.bind((0, _assertThisInitialized2.default)(_this));
    window.addEventListener('resize', _this.measureWidth);
    return _this;
  }

  (0, _createClass2.default)(UIStepIndicator, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      // ⚠️ This condition prevents infinite loops! ⚠️
      if (prevState.isWidthConstrained === this.state.isWidthConstrained) {
        this.measureWidth();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.measureWidth);
    }
  }, {
    key: "refCallback",
    value: function refCallback(ref) {
      this._el = ref;
      this.measureWidth();
    }
  }, {
    key: "measureWidth",
    value: function measureWidth() {
      var _this$props = this.props,
          direction = _this$props.direction,
          responsiveBreakpoint = _this$props.responsiveBreakpoint,
          use = _this$props.use;
      if (use === 'compact' || direction !== 'horizontal' || !this._el) return;

      if (this.state.isWidthConstrained) {
        this._el.classList.remove('private-step-indicator--compact');
      } // Measure width of wrapper and compare against threshold


      var isWidthConstrained = this._el.clientWidth < responsiveBreakpoint;

      if (isWidthConstrained !== this.state.isWidthConstrained) {
        this.setState({
          isWidthConstrained: isWidthConstrained
        });
      }

      if (this.state.isWidthConstrained) {
        this._el.classList.add('private-step-indicator--compact');
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          circleSize = _this$props2.circleSize,
          className = _this$props2.className,
          direction = _this$props2.direction,
          onStepClick = _this$props2.onStepClick,
          stepIndex = _this$props2.stepIndex,
          stepNames = _this$props2.stepNames,
          StepIconComponent = _this$props2.StepIconComponent,
          use = _this$props2.use;
      var isWidthConstrained = this.state.isWidthConstrained;
      var classes = (0, _classNames.default)(className, 'private-step-indicator', {
        'private-step-indicator--customized': StepIconComponent !== DefaultStepIconComponent,
        'private-step-indicator--horizontal': direction === 'horizontal',
        'private-step-indicator--vertical': direction === 'vertical',
        'private-step-indicator--compact': use === 'compact' || isWidthConstrained,
        'private-step-indicator--flush private-step-indicator--compact': use === 'flush'
      });
      return _react.default.createElement("div", {
        className: classes,
        direction: direction,
        ref: this.refCallback
      }, renderSteps(circleSize, direction, onStepClick, stepIndex, stepNames, StepIconComponent), direction === 'horizontal' ? _react.default.createElement("span", {
        "aria-hidden": true,
        className: "private-step-indicator__item private-step-indicator__status"
      }, stepNames[stepIndex]) : null);
    }
  }]);
  return UIStepIndicator;
}(_react.PureComponent);

UIStepIndicator.propTypes = {
  circleSize: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.oneOf(Object.keys(_IconConstants.ICON_SIZES))]),
  direction: _react.PropTypes.oneOf(['horizontal', 'vertical']).isRequired,
  responsiveBreakpoint: _react.PropTypes.number,
  onStepClick: _react.PropTypes.func,
  stepIndex: _react.PropTypes.number,
  stepNames: _react.PropTypes.arrayOf(_react.PropTypes.node.isRequired).isRequired,
  StepIconComponent: _component.default,
  use: _react.PropTypes.oneOf(['default', 'compact', 'flush'])
};
UIStepIndicator.defaultProps = {
  circleSize: 10,
  direction: 'horizontal',
  responsiveBreakpoint: 500,
  StepIconComponent: DefaultStepIconComponent,
  use: 'default'
};
UIStepIndicator.displayName = 'UIStepIndicator';
var _default = UIStepIndicator;
exports.default = _default;
module.exports = exports.default;